import React, { useEffect, useState } from "react";
import DoMainStyle from "./domain.module.css";
import { Button, Form, Select, Upload, Input, Col, Row } from "antd";
import { UploadOutlined } from "@ant-design/icons";
const { TextArea } = Input;
function DoMain() {
  const [form] = Form.useForm();
  const [fileContent, setFileContent] = useState("");
  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };
  const contentUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const content = event.target.result;
      setFileContent(content);
      console.log(content);
    };
    reader.readAsText(file);
    return false; // 阻止默认上传行为
  };
  useEffect(() => {
    form.setFieldsValue({
      gene_id_text: fileContent,
    }); // 初始化时更新文本域的值
  }, [fileContent]);
  return (
    <div className={DoMainStyle.DoMain_app}>
      <div className={DoMainStyle.DoMain_Header}>
        <p>Domain Search</p>
      </div>
      <div className={DoMainStyle.HeatMapPage_FormDiv}>
        {/* <div className={DoMainStyle.HeatMapPage_FormDiv_header}>
          <p>Domain search</p>
        </div> */}
        <Form
          form={form}
          onFinish={onFinish}
          style={{ width: "60%", margin: "20px auto" }}
        >
          <Form.Item
            label={<span style={{ fontWeight: "bold" }}>Dataset/Species</span>}
            name="dataset_species"
          >
            <Select options={[
              {
                key:"1",
                label:"Sugarcane",
                value:"Sugarcane",
              },
              {
                key:"2",
                label:"GXS87-16",
                value:"GXS87-16"
              },{
                key:"3",
                label:"AP85-441",
                value:"AP85-441"
              },{
                key:"4",
                label:"CC_01_1940Ecotype:Colombia",
                value:"CC_01_1940Ecotype:Colombia"
              },{
                key:"5",
                label:"LA-purple",
                value:"LA-purple"
              },
              {
                key:"6",
                label:"NP-X",
                value:"NP-X"
              },
              {
                key:"7",
                label:"KK3",
                value:"KK3"
              },
              {
                key:"8",
                label:"R570",
                value:"R570"
              },
              {
                key:"9",
                label:"ZZ1",
                value:"ZZ1"
              },
              {
                key:"10",
                label:"YN2009-3",
                value:"YN2009-3"
              },{
                key:"11",
                label:"XTT22",
                value:"XTT22"
              },{
                key:"12",
                label:"YN83-224",
                value:"YN83-224"
              },
              {
                key:"13",
                label:"Arabidopsis thaliana",
                value:"Arabidopsis thaliana"
              },{
                key:"14",
                label:"Rice",
                value:"Rice"
              }
            ]} />
          </Form.Item>
          {/* */}
          <Form.Item
            label={<span style={{ fontWeight: "bold" }}>Gene/Protein ID</span>}
            name="gene_id_text"
          >
            <TextArea style={{ height: 150 }} />
          </Form.Item>
          <Row>
            <Col span={12}>
              <Form.Item
                colon={false}
                label={
                  <span style={{ color: "transparent" }}>41556465465465</span>
                }
                name="SN"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                style={{
                  width: "60%",
                }}
              >
                <Upload
                  beforeUpload={contentUpload}
                  name="SN"
                  action="/upload.do"
                  onRemove={() => {
                    setFileContent("");
                  }}
                >
                  <Button
                    style={{
                      border: "none",
                      padding: "0",
                      margin: "0",
                      background: "transparent",
                    }}
                    icon={<UploadOutlined />}
                  >
                    Click to upload
                  </Button>
                </Upload>
              </Form.Item>
            </Col>
            <Col span={12} style={{ display: "flex", justifyContent: "end" }}>
              <Button style={{ border: "none", background: "transparent" }}
              onClick={()=>{
                form.setFieldsValue({dataset_species: "example",gene_id_text:"example"})
              }}
              >
                Click here to get example
              </Button>
            </Col>
          </Row>
          <Form.Item
            colon={false}
            label={<span style={{ color: "transparent" }}>41556465465465</span>}
          >
            <Row>
              <Col style={{ display: "flex", alignItems: "center" }} span={12}>
                <Button htmlType="submit" style={{ width: "80%" ,background:"#6C5E6E",color:"white"}}>Submit</Button>
              </Col>
              <Col style={{ display: "flex", alignItems: "center" }} span={12}>
                <Button style={{ width: "80%",border:"1px solid #6C5E6E",color:"#6C5E6E" }}
                onClick={()=>{
                  form.resetFields()
                  setFileContent("")
                }}
                >Reset</Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default DoMain;
